import { chakra } from "@chakra-ui/react";
import OtpInput from "react-otp-input";

import styles from "./VerificationCode.module.css";

interface VerificationCodeProps {
  value: string;
  onChange: (value: string) => void;
  length: number;
}
export const VerificationCode = ({
  value,
  onChange,
  length,
}: VerificationCodeProps) => {
  return (
    <OtpInput
      value={value}
      onChange={onChange}
      numInputs={length || 6}
      containerStyle={styles.verificationCodeContainer}
      shouldAutoFocus
      renderInput={(props, index) => {
        const filled = Boolean(props.value);
        const isFirst = index === 0;
        const isLast = index === (length || 6) - 1;
        return (
          <chakra.input
            {...props}
            autoComplete="one-time-code"
            inputMode="text"
            autoCapitalize="characters"
            autoCorrect="off"
            spellCheck={false}
            textAlign="center"
            borderWidth="1px"
            borderLeftWidth={isFirst ? "1px" : "0"}
            borderColor={filled ? "border.brand" : "border.default"}
            borderStyle="solid"
            borderTopLeftRadius={isFirst ? "md" : "0"}
            borderBottomLeftRadius={isFirst ? "md" : "0"}
            borderTopRightRadius={isLast ? "md" : "0"}
            borderBottomRightRadius={isLast ? "md" : "0"}
            width={{ base: "2.75rem", sm: "3.25rem" }}
            height={{ base: "3rem", sm: "3.5rem" }}
            minWidth={{ base: "2.75rem", sm: "3.25rem" }}
            flex="0 0 auto"
            padding="0"
            fontSize="1.5rem"
            fontWeight="600"
            color="fg.default"
            bg="bg.canvas"
            position="relative"
            transition="border-color 120ms ease, box-shadow 120ms ease, z-index 0s"
            _focus={{
              outline: "none",
              borderColor: "border.brand",
              borderWidth: "2px",
              borderLeftWidth: "2px",
              boxShadow: "0 0 0 4px rgba(57, 184, 125, 0.18)",
              zIndex: 1,
            }}
          />
        );
      }}
    />
  );
};
